<template>
  <b-button :pressed="pressed" @click="toggleRoute" v-html="buttonText" style="margin-right: 0.75rem" variant="link">
  </b-button>
</template>

<script>
import {mapGetters} from "vuex";
import { Item } from "@/utils/model";

export default {
  props: {
    item: {
      type: Item
    }
  },
  methods: {
    toggleRoute () {
      if (this.pressed) {
        this.$store.commit('jobs/removeRoute', this.item)
      } else {
        this.$store.commit('jobs/addRoute', this.item)
      }
    }
  },
  computed: {
    buttonText () {
      return this.pressed ? "Entfernen" : "Anzeigen"
    },
    ...mapGetters('jobs', ['isSelected']),
    pressed () {
      return this.isSelected(this.item.id)
    }
  }
}
</script>